import { Form } from "react-router-dom";
import { Box, Button, Heading, Link } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { useNavigate } from "react-router-dom";

export default function Fail() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const navigate = useNavigate();

  return (
    <div>
      <Form>
        <Box>
          <Heading headingRef={h2Ref} focusable id="sendFailedHeading">
            Något gick fel
          </Heading>
          <p>Något verkar ha gått fel i din anmälan. Testa gärna igen.</p>
          <p>
            Har du frågor kan du kontakta kundservice på{" "}
            <Link className="inline!" underline="always" href="tel:0771-21 10 10">
              0771-21 10 10
            </Link>
          </p>
        </Box>
        <div className="flex justify-center">
          <div className="w-full text-left flex items-center">
            <Button
              iconPosition="left"
              iconSize={16}
              iconName="arrow-left"
              aria-label="Tillbaka"
              showIcon
              size="medium"
              variant="outline"
              onClick={(event) => {
                event.preventDefault();
                const backUrl = undefined;
                if (backUrl) {
                  navigate(backUrl, { replace: true });
                } else {
                  navigate(-1);
                }
              }}
            >
              Tillbaka
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
